<template>
  <div>
    <el-card class="mb5">
      <el-form
        ref="formSearch" :model="queryForm" label-position="top"
        size="small"
      >
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item :label="$t('vehicle.billingPeriod')">
              <el-select
                v-model="queryForm.params.billPeriodList"
                :placeholder="$t('placeOrder.pleaseChoose')"
                clearable
                collapse-tags
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in billPeriodList" :key="item" :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('collectionCenter.region')">
              <el-select
                v-model="queryForm.params.regionIdList"
                :placeholder="$t('placeOrder.pleaseChoose')"
                clearable
                collapse-tags
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.zhName + '（' + item.puName + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 网点所属州 -->
          <el-col :span="4">
            <el-form-item :label="$t('collectionCenter.stateSite1')">
              <el-select
                v-model="queryForm.params.stateList"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                collapse-tags
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in StateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 责任网点 -->
          <el-col :span="5">
            <el-form-item :label="$t('fixDutyFine.ResponsibleBranch')">
              <el-select
                v-model="queryForm.params.siteIdList"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                collapse-tags
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!--  网点类型      -->
          <el-col :span="4">
            <el-form-item :label="$t('home.siteType')">
              <el-select
                v-model="queryForm.params.businessModel"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option :value="1" label="AJD" />
                <el-option :value="2" label="DSP" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('GlobalSetObj.status')">
              <el-select
                v-model="queryForm.params.status"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option :label="$t('home.pendingConfirmation')" :value="1" />
                <el-option :label="$t('GlobalSetObj.Confirmed')" :value="2" />
                <el-option :label="$t('vehicle.inDispute')" :value="3" />
                <el-option :label="$t('Resource.Approved')" :value="4" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('vehicle.isUpdated')">
              <el-select
                v-model="queryForm.params.updateFlag"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option :label="$t('vehicle.yes')" :value="1" />
                <el-option :label="$t('vehicle.no')" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <div style="margin-top: 27px">
              <el-button
                icon="el-icon-search" size="small" type="primary"
                @click="searchResources(1)"
              >{{ $t('operationCenter.Procurar') }}
              </el-button>
              <el-button icon="el-icon-refresh-left" size="small" @click="searchResources(2)">
                {{ $t('operationCenter.reset') }}
              </el-button>
              <el-button
                icon="el-icon-upload2"
                size="small"
                style="margin-bottom: 10px"
                type="primary"
                @click="allExportOrder"
              >{{ $t('newOrder.export') }}
              </el-button>
              <el-radio-group v-model="queryForm.params.isTest" size="small" style="margin: 0 10px">
                <el-radio-button :label="1">{{ $t('newOrder.Formal') }}</el-radio-button>
                <el-radio-button :label="2">{{ $t('newOrder.test1') }}</el-radio-button>
              </el-radio-group>
              <el-button
                v-permit:remove="'btn:DeductionConfirmationForm:handleFinalAudit'"
                size="small"
                type="warning"
                @click="handleFinalAudit(1)"
              >{{ $t('base.finalReview') }}
              </el-button>
              <el-button
                v-permit:remove="'btn:DeductionConfirmationForm:fixTime'"
                size="small"
                @click="handleFinalAudit(2)"
              >{{ $t('home.fixTime') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
        border
        @selection-change="handleSelectionChange"
      >
        <!-- 复选框列 -->
        <el-table-column align="center" type="selection" width="55" />
        <el-table-column
          :label="$t('vehicle.reconciliationStatementNumber')"
          align="center"
          prop="billNo"
          width="150"
        />
        <el-table-column
          :label="$t('vehicle.billingPeriod')"
          align="center"
          prop="billPeriod"
          width="120"
        />
        <el-table-column
          :label="$t('collectionCenter.region')"
          align="center"
          prop="regionName"
          width="100"
        />
        <el-table-column
          :label="$t('collectionCenter.stateSite1')"
          align="center"
          prop="state"
          width="120"
        />
        <el-table-column
          :label="$t('fixDutyFine.ResponsibleBranch')"
          align="center"
          prop="siteName"
          width="140"
        />
        <!-- 状态列（带颜色标签） -->
        <el-table-column
          :label="$t('GlobalSetObj.status')"
          align="center"
          prop="statusStr"
          width="100"
        >
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.statusStr)" size="small">
              {{ scope.row.statusStr }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('vehicle.totalPenaltyAmount')"
          align="center"
          prop="totalPenaltyAmountStr"
          width="120"
        />
        <!-- 明细列 -->
        <el-table-column :label="$t('customerManagements.detailTitle')" align="center" width="80">
          <template slot-scope="scope">
            <el-button
              v-permit:remove="'btn:DeductionConfirmationForm:seeDetail'"
              style="color: #00A551"
              type="text"
              @click="handleViewDetail(scope.row)"
            >{{ $t('customerManagements.View') }}
            </el-button>
          </template>
        </el-table-column>
        <!-- 是否已更新列（带颜色标签） -->
        <el-table-column
          :label="$t('vehicle.isUpdated')"
          align="center"
          prop="updateFlagStr"
          width="100"
        >
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.updateFlagStr === $t('vehicle.yes') ? 'primary' : 'danger'"
              size="small"
            >
              {{ scope.row.updateFlagStr }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('vehicle.confirmationDeadline')"
          align="center"
          prop="confirmDeadline"
          width="160"
        />
        <el-table-column
          :label="$t('vehicle.remainingTimeHours')"
          align="center"
          prop="remainingTime"
          width="120"
        />
        <el-table-column
          :label="$t('collectionCenter.verifyTime')"
          align="center"
          prop="confirmTime"
          width="160"
        />
        <el-table-column
          :label="$t('collectionCenter.verifyPerson')"
          align="center"
          prop="confirmUser"
          width="120"
        />
        <el-table-column
          :label="$t('vehicle.finalReviewTime')"
          align="center"
          prop="auditTime"
          width="160"
        />
        <el-table-column
          :label="$t('vehicle.finalReviewer')"
          align="center"
          prop="auditUser"
          width="120"
        />
        <!-- 操作列（图标按钮） -->
        <el-table-column
          :label="$t('trajectory.operate')" align="center" fixed="right"
          width="100"
        >
          <template slot-scope="scope">
            <div class="flx-around" style="cursor: pointer">
              <el-tooltip
                v-if="[2].includes(scope.row.status)"
                v-permit:remove="'btn:DeductionConfirmationForm:handleDeduction'"
                :content="$t('base.finalReview')"
                class="box-item"
                effect="dark"
                placement="top"
              >
                <span
                  class="iconfont icon-a-zu949"
                  style="color: #00A551"
                  @click="handleDeduction(scope.row, 1)"
                />
              </el-tooltip>
              <el-tooltip
                v-permit:remove="'btn:DeductionConfirmationForm:handleDetail'"
                :content="$t('vehicle.viewConfirmationDocument')"
                class="box-item"
                effect="dark"
                placement="top"
              >
                <span class="iconfont icon-a-zu1279" @click="handleDeduction(scope.row, 2)" />
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="getCurrentTableData"
          @size-change="getSizeTableData"
        />
      </div>
    </el-card>
    <!-- 账单明细-->
    <el-drawer
      :title="$t('vehicle.billDetails')"
      :visible.sync="dialogVisible"
      center
      direction="ltr"
      size="1200px"
      @close="closeDrawer"
    >
      <packageDetail
        v-if="dialogVisible"
        ref="votesDetails"
        :dataobj="dataObj"
        @call-parent-method="parentMethod"
      />
    </el-drawer>
    <tipCom ref="tipComRef" @call-parent-search="getSearch" />
    <fixTime ref="fixTimeRef" @call-parent-search="getSearch" />
    <confirmDeduction ref="confirmDeductionRef" @call-parent-search="getSearch" />
  </div>
</template>

<script>
import { getLgAreaListData, regionQueryList } from '@/api/orderApi';
import { goResourceTaskList } from '@/utils/goExportList';
import {
  getLmPenaltyBillPage,
  lmPenaltyBillExport,
  lmPenaltyBillPeriod
} from '@/api/definiteResponsibilityAndPenalty';
import { siteQueryOwnSite } from '@/api/lanshou';

export default {
  name: 'ReturnDataMonitoring',
  components: {
    packageDetail: () => import('./component/packageDetail'),
    tipCom: () => import('./component/tipCom.vue'),
    fixTime: () => import('./component/fixTime.vue'),
    confirmDeduction: () => import('./component/confirmDeduction.vue')
  },
  data() {
    return {
      allSiteListCache: null,
      sitesByRegionAndState: {},
      regionList: [],
      dialogVisible: false, // 详情弹窗
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          regionIdList: [],
          stateList: [],
          siteIdList: [],
          status: '',
          billPeriodList: [],
          isTest: 1,
          businessModel: null,
          updateFlag: null
        }
      },
      tableData: [],
      total: 0,
      StateList: [], // 州
      siteList: [],
      dataObj: {},
      selectedRows: [],
      billPeriodList: []
    };
  },
  created() {
    // 获取加盟商选项
    this.getAddress();
    this.getRegion();
    this.getLmPenaltyBillPeriod();
    this.getBranchList();
  },
  methods: {
    // 1. 点击账单审核按钮
    handleFinalAudit(val) {
      // 1. 先判断有没有选中数据
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('GlobalSetObj.CheckForm'));
        return;
      }
      if (val === 1) {
        // 2. 弹出确认框
        this.$refs.tipComRef.showTIP(this.selectedRows);
      } else {
        this.$refs.fixTimeRef.showFixTip(this.selectedRows);
      }
    },
    handleDeduction(row, btn) {
      console.log(row, btn, 'handleDeduction');
      row.btn = btn;
      this.$refs.confirmDeductionRef.showDeductionDialog(row);
    },
    // 复选框选中变化
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    getSearch() {
      if (this.queryForm.params.billPeriodList.length === 0) {
        this.$message.error(this.$t('scripting.selectBillingPeriod'));
        return;
      }
      getLmPenaltyBillPage(this.queryForm).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 状态类型映射（对应标签颜色）
    getStatusType(status) {
      const statusMap = {
        // 中文
        待确认: 'primary',
        已确认: 'success',
        对质中: 'warning',
        已审核: 'info',
        Pendente: 'primary',
        Confirmado: 'success',
        'Em validação': 'warning',
        Aprovado: 'info'
      };
      return statusMap[status] || 'info';
    },
    // 查看明细
    handleViewDetail(row) {
      this.dataObj = row;
      this.dialogVisible = true;
    },
    // 搜索、重置
    searchResources(type) {
      if (type === 1) {
        this.queryForm.pageNumber = 1;
        this.getSearch();
      } else {
        this.queryForm = {
          pageSize: 10,
          pageNumber: 1,
          params: {
            regionIdList: [],
            stateList: [],
            siteIdList: [],
            status: '',
            billPeriodList: [this.billPeriodList[0]],
            isTest: 1,
            businessModel: null,
            updateFlag: null
          }
        };
        this.getSearch();
      }
    },
    allExportOrder() {
      if (this.queryForm.params.billPeriodList.length === 0) {
        this.$message.error(this.$t('scripting.selectBillingPeriod'));
        return;
      }
      const data = this.queryForm.params;
      lmPenaltyBillExport(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 页码变化翻页
    getCurrentTableData(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    // 每页显示数量变化
    getSizeTableData(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getSearch();
    },
    closeDrawer() {
      this.dialogVisible = false;
    },
    parentMethod(arg) {
      this.dialogVisible = arg;
    },
    // 州
    getAddress() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    // 获取账期
    getLmPenaltyBillPeriod() {
      lmPenaltyBillPeriod().then((res) => {
        if (res.code === 200 && Array.isArray(res.data)) {
          this.billPeriodList = res.data;
          this.queryForm.params.billPeriodList = [this.billPeriodList[0]];
          this.getSearch();
        }
      });
    },
    // 大区
    getRegion() {
      regionQueryList(3).then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    // 查询所有网点
    getBranchList() {
      siteQueryOwnSite().then((res) => {
        if (res.code === 200) {
          this.siteList = res.data;
        }
      });
    }
  }
};
</script>

<style scoped>
.app-container >>> .el-drawer__header {
  margin-bottom: 10px;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 20px;
  color: black;
}

.table-active {
  color: #00A551;
  cursor: pointer;
}
</style>
